import React from "react";
import { useParams } from "react-router";
import { Container, Typography, Button } from "@mui/material";
import TemplateDetailLayout from "../../components/sections/templates/TemplateDetailLayout";
import { getTemplateBySlug } from "../../data/template-registry";

export const TemplateDetailPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return <NotFound />;
  }

  const template = getTemplateBySlug(slug);

  if (!template) {
    return <NotFound slug={slug} />;
  }

  return <TemplateDetailLayout template={template} />;
};

function NotFound({ slug }: { slug?: string }) {
  return (
    <Container maxWidth="md" sx={{ py: 12, textAlign: "center" }}>
      <Typography variant="h2" component="h1" gutterBottom fontWeight={800}>
        Template Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        {slug
          ? `The template "${slug}" doesn't exist or hasn't been published yet.`
          : "No template slug was provided."}
      </Typography>
      <Button href="/templates" variant="contained" color="primary">
        Browse All Templates
      </Button>
    </Container>
  );
}

export default TemplateDetailPage;
